var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6002 6.4743C15.9166 5.69392 15.5399 4.69173 15.5402 3.6543H12.4502V16.0543C12.4263 16.7253 12.143 17.3609 11.6599 17.8272C11.1768 18.2936 10.5316 18.5542 9.86016 18.5543C8.44016 18.5543 7.26016 17.3943 7.26016 15.9543C7.26016 14.2343 8.92016 12.9443 10.6302 13.4743V10.3143C7.18016 9.8543 4.16016 12.5343 4.16016 15.9543C4.16016 19.2843 6.92016 21.6543 9.85016 21.6543C12.9902 21.6543 15.5402 19.1043 15.5402 15.9543V9.6643C16.7932 10.5641 18.2975 11.0469 19.8402 11.0443V7.9543C19.8402 7.9543 17.9602 8.0443 16.6002 6.4743Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.4e43744aeb5da7723b1f13ece68111e5.svg";
export { ForwardRef as ReactComponent };